import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import { FetchStatus } from "../../../globalConsts";
import { fetchNavMenuPartition as requestFetchNavMenuPartition } from "../../../requests/globalRequests/requestCreators";
import { fetchAllModulesMetadata } from "../../../requests/modules/requestCreators";
import { requestGetUser } from "../../../requests/users/requestCreators";
import {
  isImpersonatingRequest,
  isImpersonatingSuccess,
} from "../../impersonation/actionCreators";
import { getLocaleString } from "../../localization/selectors";
import requestLanguage from "../../localization/thunks/getLanguage";
import {
  errorIsAdmin,
  requestIsAdmin,
  successIsAdmin,
} from "../../login/actionCreators/authentication/isUserAdminCreator";
import {
  requestFetchAllModulesMetadata,
  successFetchAllModulesMetadata,
} from "../../modules/actions";
import {
  isPersonalizationFetching,
  receiveServerPersonalization,
} from "../../personalization/actionCreators";
import { requestFetchVisibleOverviewTemplatesMetadata } from "../../templateMetadata/actions";
import { FlowioThunkCreator } from "../../types";
import {
  setIsLoading,
  setUserInfo,
  setUserSettings,
} from "../../user/actionCreators";
import * as AC from "../actionCreators";
import * as S from "../selectors";

type ThunkCreator = FlowioThunkCreator<void>;

export const fetchNavMenuPartition: ThunkCreator = () => (dispatch, getState) =>
  Promise.resolve().then(async () => {
    const status = S.getStatusForGlobalFetchPartition(getState(), "navMenu");
    if (status !== FetchStatus.Uninitialized) return;

    dispatch(AC.requestFetchGlobalPartition({ partition: "navMenu" }));

    dispatch(isImpersonatingRequest());
    dispatch(requestFetchAllModulesMetadata());
    dispatch(isPersonalizationFetching({ flag: true }));
    dispatch(setIsLoading({ isLoading: true }));
    dispatch(requestIsAdmin());
    dispatch(requestLanguage());

    try {
      const moduleMetadata = await fetchAllModulesMetadata();
      const massResponse = await requestFetchNavMenuPartition();

      const {
        isImpersonating,
        isUserAdmin,
        loginWithCookie,
        personalizationConfig,
        userPersonalization,
      } = massResponse.data;

      dispatch(isImpersonatingSuccess({ userId: isImpersonating }));

      dispatch(successFetchAllModulesMetadata(moduleMetadata.data));

      dispatch(
        receiveServerPersonalization({
          personalizationData: personalizationConfig,
        })
      );

      dispatch(
        setUserSettings({
          userSettings: {
            ...userPersonalization,
            language: getLocaleString(getState()),
            stateChanged: false,
          },
        })
      );

      dispatch(isPersonalizationFetching({ flag: false }));
      dispatch(successIsAdmin(isUserAdmin));

      const { userId, token } = loginWithCookie;

      // todo: Authorization
      if (token) {
        setLocalStorageLoginToken(token);
      }

      const userResponse = await requestGetUser(userId);

      const { userName, email, showedGuide } = userResponse.data;
      const userInfo = { userName, email, showedGuide, stateChanged: false };
      dispatch(setUserInfo({ userInfo }));
      dispatch(setIsLoading({ isLoading: false })); // pro userSettings i userInfo

      dispatch(AC.receiveFetchGlobalPartition({ partition: "navMenu" }));
    } catch (e) {
      dispatch(AC.errorFetchGlobalPartition({ partition: "navMenu" }));
      dispatch(isPersonalizationFetching({ flag: false }));
      dispatch(setIsLoading({ isLoading: false })); // pro userSettings i userInfo
      dispatch(errorIsAdmin(undefined));
    }
  });
